<h1>Novo Aditivo da PAC <span *ngIf="pac">{{pac?.propostaNumero}} / {{pac?.propostaAno}}</span></h1>

<div *ngIf="!podeAditar" class="alert alert-danger">
    <p>A operação relacionada a esta PAC não está ativa, logo não pode ser aditada.</p>
</div>

<h5>Dados da PAC</h5>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Proposta / Ano</h6>
                <p>{{pac?.propostaNumero}} / {{pac?.propostaAno}}</p>
            </div>
            <div class="col-sm-7 col-12">
                <h6 class="mb-0">Programa / Linha</h6>
                <p title="Programa-Linha: {{pac?.programaId | number:'3.0-0'}}-{{pac?.linhaId | number:'3.0-0'}}">
                    {{pac?.programaNome}} / {{pac?.linhaNome}}
                </p>
            </div>
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Número PAC</h6>
                <p>{{pac?.numeroPac | number:'6.0' | bnMask:'99.999-9'}}</p>
            </div>
        </div>
    </div>
</div>

<h5>Dados da Beneficiária</h5>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNPJ / CPF</h6>
                <!-- input class="form-control" bnMask="CNPJCPF" [(ngModel)]="cnpjCpf" name="cnpjCpf" -->
                <input class="form-control col-12" bnMask="CNPJCPF" [(ngModel)]="cnpjCpf" name="cnpjCpf"
                       (ngModelChange)="onMudaComprador($event)">
                <!-- bn-autocomplete-empresa  [(ngModel)]="comprador"
                                name="autocompleteEmpresa"
                                [placeholder]="'Empresa inicial'"
                                [bnMaxHeight]="7"></bn-autocomplete-empresa -->

                <!--p>{{cnpjCpf | bnMask: 'CNPJCPF'}}
                    <span *ngIf="aditivo?.compradorNome"> - {{aditivo?.compradorNome}} </span>
                </p-->
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Razão Social</h6>
                <p>{{compradorNome}}</p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNAE Comprador</h6>
                <bn-autocomplete-cnae [(ngModel)]="compradorCnae" name="autocompleteCNAEComprador"
                                      [bnMaxHeight]="7"></bn-autocomplete-cnae>
            </div>
        </div>


        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">ROB Beneficiária (R$)</h6>
                <input class="form-control col-12" bnMask="MOEDA" [(ngModel)]="rob.valor" name="robValor">
                <p><small>{{rob.valor | bnValorPorExtenso : 'monetario' : 'BRL'}}</small></p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Data de Referência</h6>
                <!--bn-datepicker [minDate]="minDate" [maxDate]="maxDate"></bn-datepicker-->
                <bn-datepicker [(ngModel)]="rob.dataReferencia"></bn-datepicker>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Tipo de Renda</h6>
                <select [(ngModel)]="rob.tipo" class="form-select col-12">
                    <option value="null"></option>
                    <option value="E">Efetivo</option>
                    <option value="P">Previsto</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">ROB do Grupo Econômico (R$)</h6>
                <input class="form-control col-12" bnMask="MOEDA" [(ngModel)]="robGrupo.valor" name="robGrupoValor">
                <p><small>{{robGrupo.valor | bnValorPorExtenso : 'monetario' : 'BRL'}}</small></p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Data de Referência</h6>
                <!--bn-datepicker [minDate]="minDate" [maxDate]="maxDate"></bn-datepicker-->
                <bn-datepicker [(ngModel)]="robGrupo.dataReferencia"></bn-datepicker>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Tipo de Renda</h6>
                <select [(ngModel)]="robGrupo.tipo" class="form-select col-12">
                    <option value="null"></option>
                    <option value="E">Efetivo</option>
                    <option value="P">Previsto</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNPJ Líder Grupo</h6>
                <input class="form-control col-12" bnMask="CNPJ" [(ngModel)]="cnpjLiderGrupo" name="cnpjLiderGrupo">
                <p>{{cnpjLiderGrupo | bnMask: 'CNPJ'}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Porte</h6>
                <select [(ngModel)]="porteEmpresa" class="form-select col-12">
                    <option value="null" disabled>Não Informado</option>
                    <option value="8">Micro</option>
                    <option value="9">Pequena</option>
                    <option value="2">Media</option>
                    <option value="11">Media II</option>
                    <option value="3">Grande</option>
                </select>
                <!-- p>{{porteEmpresa}}</p -->
            </div>
        </div>

        <br>

        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Caracterização do Capital Social</h6>
                <select [(ngModel)]="caractCapitalSocial" class="form-select col-12">
                    <option value="0">Não Informado</option>
                    <option value="5">100% BRASILEIRA</option>
                    <option value="6">&lt;50% part. estrangeira e CONTROLE NACIONAL</option>
                    <option value="7">&lt;50% part. estrangeira e CONTROLE ESTRANGEIRO</option>
                    <option value="8">&ge;50% ESTRANGEIRA</option>
                </select>
                <!--p>{{caractCapitalSocial}}</p-->
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Atividade Decreto 2.233/1997</h6>
                <select [(ngModel)]="indAtividadeDecreto" class="form-select col-12">
                    <option [ngValue]="null">Não Informado</option>
                    <option [ngValue]="true">Sim</option>
                    <option [ngValue]="false">Não</option>
                </select>
                <!--p>{{indAtividadeDecreto}}</p-->
            </div>
        </div>
    </div>
</div>

<!--hr/-->

<h5>Dados do Investimento</h5>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNPJ Investimento</h6>
                <input class="form-control col-12" bnMask="CNPJ" [(ngModel)]="cnpjInvestimento" name="cnpjInvestimento">
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNAE Investimento</h6>
                <bn-autocomplete-cnae [(ngModel)]="cnaeInvestimento" name="autocompleteCNAE"
                                      [bnMaxHeight]="7"></bn-autocomplete-cnae>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Município de Instalação</h6>
                <bn-autocomplete-area-geografica [(ngModel)]="municipioInstalacao"
                                                 name="autocompleteAreaGeo"
                                                 [placeholder]="'Município de Instalação'"
                                                 [bnMaxHeight]="7"
                                                 [tipoAreaGeografica]="[1]"></bn-autocomplete-area-geografica>

                <!--input class="col-12" [(ngModel)]="municipioInstalacao" name="municipioInstalacao"-->
            </div>
        </div>
    </div>
</div>

<!--hr/-->

<div class="row">
    <div class="col-12">
        <h6 class="mb-0">Comentário</h6>
        <textarea class="col-12" [(ngModel)]="comentario" autosize rows="4"
                  [placeholder]="'Descreva este aditivo...'"></textarea>
    </div>
</div>

<div *ngIf="erros" class="alert alert-danger">
    <h5 class="alert alert-danger"><i class="fa fa-exclamation-triangle me-1 error" aria-hidden="true"></i>Foram
        encontrados erros na validação deste aditivo.</h5>
    <p>Favor verificar os erros abaixo.</p>
    <ul>
        <li *ngFor="let e of erros">{{e.msg}}</li>
    </ul>
</div>

<div *ngIf="!podeAditar" class="alert alert-danger">
    <p>A operação relacionada a esta PAC não está ativa, logo não pode ser aditada.</p>
</div>


<div class="col-12 mt-1">
    <button class="btn btn-primary" (click)="onEnviarAditivo()" [disabled]="!podeSubmeterAditivo()">
        <!-- i class="fa fa-ban me-1" aria-hidden="true"></i -->
        Enviar Aditivo
    </button>
</div>
